import DOMPurify from "dompurify"

export const sanitizeProductHtml = (html) => {
	if (!html) return html

	return DOMPurify.sanitize(html, {
		FORBID_TAGS: [
			"base",
			"button",
			"canvas",
			"embed",
			"form",
			"iframe",
			"input",
			"link",
			"math",
			"meta",
			"object",
			"script",
			"select",
			"source",
			"style",
			"svg",
			"textarea",
			"track",
			"video",
		],
		FORBID_ATTR: ["style", "srcdoc", "formaction"],
	})
}
